var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgManagementOffice = function SvgManagementOffice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 19,
    x: 2.5,
    y: 0.5,
    rx: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 19,
    x: 2.5,
    y: 0.5,
    stroke: "currentColor",
    rx: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M9.639 11.71 12.195 9M9.578 11.71l-1.387-1.5M12.493 5.5l.018.105.006.023c.38 1.432 1.244 2.097 1.983 2.3V10.5l-.008.195c-.08.978-.756 1.958-1.706 2.836-.91.842-1.997 1.514-2.786 1.91-.789-.396-1.875-1.068-2.786-1.91C6.2 12.595 5.5 11.541 5.5 10.5V7.929c.74-.204 1.604-.87 1.983-2.301l.006-.023.018-.105z"
  })));
};
export default SvgManagementOffice;